// extracted by mini-css-extract-plugin
module.exports = {"button":"ShakeEntrypoint_button__358Gy","wrap":"ShakeEntrypoint_wrap__3RqiI","badge":"ShakeEntrypoint_badge__2-Ghy"};